import {createStore as _createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';

import reducer from './modules/reducer';

export default function createStore() {

    const middleware = [ thunk ];

    let finalCreateStore;
    if ( __DEVELOPMENT__ && __DEVTOOLS__ ) {
        const { persistState } = require( 'redux-devtools' );
        const DevTools = require( '../containers/DevTools' );
        finalCreateStore = compose(
            applyMiddleware( ...middleware ),
            window.devToolsExtension ? window.devToolsExtension() : DevTools.instrument(),
            persistState( window.location.href.match( /[?&]debug_session=([^&]+)\b/ ) )
        )( _createStore );
    } else {
        finalCreateStore = applyMiddleware( ...middleware )( _createStore );
    }

    const store = finalCreateStore( reducer );

    if ( __DEVELOPMENT__ && module.hot ) {
        module.hot.accept( './modules/reducer', () => {
            store.replaceReducer( require( './modules/reducer' ) );
        } );
    }

    return store;
}



// WEBPACK FOOTER //
// ./src/form/redux/store.js